import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {TokenManagerService} from './token-login.service';
import {Toast, ToasterConfig, ToasterService} from 'angular2-toaster';
import {Router} from '@angular/router';

@Injectable()
export class HttpRequestService {
  constructor(private http: Http, private toasterService: ToasterService, private router: Router) {
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body || JSON.stringify(body);
      errMsg = err.message;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    if (errMsg === 'User does not exist!') {
      this.router.navigate(['Login']);
    }

    console.log(errMsg);

    const toast: Toast = {
      type: 'error',
      title: 'Error',
      body: errMsg,
      showCloseButton: true,
      timeout: 5000
    };

    this.toasterService.pop(toast);
    return Observable.throw(errMsg);
  }

  get(url: string, showSuccessToast?: boolean, toastMessage?: string) {
    const headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', JSON.parse(TokenManagerService.getToken()).token);
    const options = new RequestOptions({headers: headers});

    const result = this.http.get(url, options)
      .map((response: Response) => {
        if (response == null) {
          return null;
        } else {

          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response.json();
        }
      })
      .catch((response) => this.handleError(response));
    return result;
  }

  post(url: string, request: any, showSuccessToast?: boolean, toastMessage?: string) {
    const headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', JSON.parse(TokenManagerService.getToken()).token);
    const options = new RequestOptions({headers: headers});
    const result = this.http.post(url, request, options)
      .map((response: Response) => {
        if (response == null) {
          return null;
        } else {
          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response.json();
        }
      })
      .catch((response) => this.handleError(response));
    return result;
  }

  delete(url: string, showSuccessToast?: boolean, toastMessage?: string) {
    const headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', JSON.parse(TokenManagerService.getToken()).token);
    const options = new RequestOptions({headers: headers});

    const result = this.http.delete(url, options)
      .map((response: Response) => {
        if (response == null) {
          return null;
        } else {
          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response.json();
        }
      })
      .catch((response) => this.handleError(response));
    return result;
  }

  put(url: string, request: any, showSuccessToast?: boolean, toastMessage?: string) {
    const headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', JSON.parse(TokenManagerService.getToken()).token);
    const options = new RequestOptions({headers: headers});
    const result =  this.http.put(url, request, options)
      .map((response: Response) => {
        if (response == null) {
          return null;
        } else {

          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response.json();
        }
      })
      .catch((response) => this.handleError(response));
    return result;
  }

  postMultipart(url: string, data: any, files: File[], showSuccessToast?: boolean, toastMessage?: string) {
    const headers = new Headers();
    headers.append('Authorization', JSON.parse(TokenManagerService.getToken()).token);
    const options = new RequestOptions({headers: headers});
    const formData: FormData = new FormData();
    formData.append('data', JSON.stringify(data));
    for (const file of files) {
      formData.append(file.name, file);
    }
    const result = this.http.post(url, formData, options)
      .map((response: Response) => {
        if (response == null) {
          return null;
        } else {

          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response.json();
        }
      })
      .catch((response) => this.handleError(response));
    return result;
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/services/http-request.service.ts